import { ReactComponent as CancelIcon } from '../../common/icons/cancel.svg';

interface DiscountBadgeProps {
  discountCode: string;
  onRemove: () => void;
  className?: string;
}

export function DiscountBadge({
  discountCode,
  onRemove,
  className = '',
}: DiscountBadgeProps) {
  return (
    <div
      className={`Giftbox-Discount-Code flex content-between items-center bg-gray-100 text-gray-900 w-fit rounded-[10px] pl-3 ${className}`}
      data-cy="discount-badge"
    >
      {discountCode}
      <button
        data-cy="selected-discount-badge-close-button "
        onClick={onRemove}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onRemove();
          }
        }}
        className="hover:cursor-pointer p-2.5 [&>svg]:fill-gray-600  [&>svg]:hover:fill-gray-800  [&>svg]:active:fill-gray-900"
      >
        <CancelIcon />
      </button>
    </div>
  );
}
